export enum ProjectType {
  INTERNAL = 1,
  EXTERNAL = 2,
}
